import gql from "graphql-tag";

export const URL = gql`
  query Url($url: String!, $anonId: String) {
    url(url: $url, anonId: $anonId) {
      success
    }
  }
`;

export const VERIFY_EMAIL = gql`
  mutation VerifyUser($verificationCode: String!) {
    verify(verificationCode: $verificationCode) {
      success
    }
  }
`;

export const REVERIFY_EMAIL = gql`
  query Reverify($debug: String) {
    reverifyEmail(debug: $debug) {
      success
    }
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation UpdateSettings(
    $day: Int
    $month: Int
    $year: Int
    $favoriteSummoners: [InputSummoner]
    $favoriteChampions: [InputChampion]
    $filterTierList: InputFilterTierList
    $filterBuildsAndRunes: InputFilterBuildsAndRunes
    $firstName: String
    $lastName: String
    $marketingOptOut: Boolean
    $startDay: Int
    $startMonth: Int
    $startYear: Int
    $primarySummoner: InputSummoner
  ) {
    updateSettings(
      birthdayDay: $day
      birthdayMonth: $month
      birthdayYear: $year
      favoriteSummoners: $favoriteSummoners
      favoriteChampions: $favoriteChampions
      filterTierList: $filterTierList
      filterBuildsAndRunes: $filterBuildsAndRunes
      firstName: $firstName
      lastName: $lastName
      marketingOptOut: $marketingOptOut
      startDay: $startDay
      startMonth: $startMonth
      startYear: $startYear
      primarySummoner: $primarySummoner
    ) {
      birthdayDay
      birthdayMonth
      birthdayYear
      email
      firstName
      lastName
      marketingOptOut
      startDay
      startMonth
      startYear
      billingSettings {
        creditCards {
          addressCity
          addressCountry
          addressLineOne
          addressLineTwo
          addressState
          addressZip
          brand
          expMonth
          expYear
          isDefault
          last4
          name
        }
      }
      lolSettings {
        summoners {
          summonerName
          regionId
          iconUrl
          iconId
          verified
        }
        favoriteChampions {
          championId
        }
        favoriteSummoners {
          summonerName
          regionId
          iconUrl
          iconId
        }
      }
      filterDefaults {
        filterTierList {
          mmr
          queueType
          regionId
          role
          showAllChampions
        }
        filterBuildsAndRunes {
          mmr
          queueType
          regionId
        }
      }
    }
  }
`;

export const LOGIN = gql`
  query Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      firstName
      lastName
      isVerified
      googleAnalyticsId
      loginState {
        token
      }
      lolSettings {
        summoners {
          isDefault
          regionId
          summonerName
          verified
          iconUrl
          iconId
        }
        favoriteChampions {
          championId
        }
        favoriteSummoners {
          regionId
          summonerName
          iconUrl
          iconId
        }
      }
      filterDefaults {
        filterTierList {
          mmr
          queueType
          regionId
          role
          showAllChampions
        }
        filterBuildsAndRunes {
          mmr
          queueType
          regionId
        }
      }
      premium {
        isPremium
        premiumVersion
        hasFailedPayment
        paymentFailureDate
      }
    }
  }
`;

export const LOGOUT = gql`
  query {
    logout {
      success
    }
  }
`;

export const GET_USER_STATE = gql`
  query {
    getState {
      firstName
      lastName
      isVerified
      googleAnalyticsId
      loginState {
        token
      }
      lolSettings {
        summoners {
          isDefault
          regionId
          summonerName
          verified
          iconUrl
          iconId
        }
        favoriteChampions {
          championId
        }
        favoriteSummoners {
          regionId
          summonerName
          iconUrl
          iconId
        }
      }
      filterDefaults {
        filterTierList {
          mmr
          queueType
          regionId
          role
          showAllChampions
        }
        filterBuildsAndRunes {
          mmr
          queueType
          regionId
        }
      }
      premium {
        isPremium
        premiumVersion
        freeTrialAvailable
        isOnFreeTrial
        hasFailedPayment
        paymentFailureDate
      }
    }
  }
`;

export const GET_USER_SETTINGS = gql`
  query {
    getSettings {
      birthdayDay
      birthdayMonth
      birthdayYear
      email
      firstName
      lastName
      marketingOptOut
      startDay
      startMonth
      startYear
      lolSettings {
        summoners {
          summonerName
          iconUrl
          iconId
          regionId
          verified
        }
      }
      filterDefaults {
        filterTierList {
          mmr
          queueType
          regionId
          role
          showAllChampions
        }
        filterBuildsAndRunes {
          mmr
          queueType
          regionId
        }
      }
      billingSettings {
        creditCards {
          last4
          brand
          expMonth
          expYear
          isDefault
          name
          addressLineOne
          addressLineTwo
          addressCity
          addressState
          addressZip
          addressCountry
        }
        paypal {
          email
        }
      }
    }
  }
`;
